<template lang="pug">
  section
    b-container
      h1 Customers
      b-form-group(label="SHOW")
        b-form-checkbox-group(:options="typeOptions", text-field="text", value-field="value", v-model="filter.type", switches, @input="getCustomers()")
      content-loader(:height="7", v-if="alert.loading")
      b-card.table-card(v-else-if="customers && customers.length > 0")
        p(v-if='customers.length < 1') No customers
        b-table(v-else="", hover, :items="customers", :fields="fields", sort-icon-left, sort-by="status_id", :sort-desc="false", responsive, borderless)
          template(v-slot:cell(compName)="row")
            span {{ row.item.company_name || row.item.name }}
            b-badge.ml-2(v-if="row.item.is_corporate") corporate
            span.d-block {{ row.item.email || row.item.name }}
            span.d-block {{ row.item.phone || row.item.name }}
          //- template(v-slot:cell(compSpend)="row") {{ formatRands(row.item.spend) }}
          template(v-slot:cell(compStatus)="row")
            b-badge(:variant="row.item.status === 'pending' ? 'dark' : 'light'") {{ row.item.status }}
      p(v-else="") No customers available
</template>

<script>

import { ContentLoader } from 'vue-content-loader';
import router from '@/router';
import standardMix from '@/mixins/standardMix';
import { apiService } from '@/services';

export default {
  name: 'Customer',
  components: {
    ContentLoader,
  },
  mixins: [standardMix],
  data() {
    return {
      customers: [],
      currentPage: 1,
      polling: null,
      lastUpdate: '',
      fields: [
        { key: 'compName', label: 'Name', sortable: true },
        // { key: 'customer_type', label: 'Type' },
        // { key: 'compSpend', label: 'Spend', sortable: true },
        { key: 'compStatus', label: 'Status' },
      ],
      // statusOptions: ['pending', 'active', 'closed'],
      // filter: {
      //   status: ['pending', 'active'],
      // },
      typeOptions: ['retail', 'corporate'],
      filter: {
        type: ['corporate', 'retail'],
      },
    };
  },
  computed: {
    totalRows() {
      return this.customers.length;
    },
  },
  methods: {
    openRow(row) {
      router.push({ name: 'Customer', params: { customerId: row.id } });
    },
    async getCustomers() {
      this.loading();
      this.customers = await apiService.getCustomers(this.filter);
      this.clear();
    },
  },
  async created() {
    await this.getCustomers();
  },
};
</script>

<style lang="scss" scoped>
  .table-responsive {
    margin-bottom: 0;
  }

  .card-body {
    padding: 0;
  }

  .logo {
    width: 200px;
    max-height: 200px;
  }
</style>



// WEBPACK FOOTER //
// src/components/views/Customers.vue